import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import EvidencePortalLogin from '../pages/EvidencePortalLogin';
import EvidencePortalPage from '../pages/EvidencePortalPage';
import { EVIDENCE_ROUTE_PATHS } from '../constants/evidenceRoutePaths';

const EvidencePortalRoute = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  return (
    <Switch>
      <Route exact path={EVIDENCE_ROUTE_PATHS.portalLogin}>
        {isAuthenticated ? (
          <Redirect to={EVIDENCE_ROUTE_PATHS.portal} />
        ) : (
          <EvidencePortalLogin />
        )}
      </Route>
      <Route exact path={EVIDENCE_ROUTE_PATHS.portal}>
        {isAuthenticated ? (
          <EvidencePortalPage />
        ) : (
          <Redirect to={EVIDENCE_ROUTE_PATHS.portalLogin} />
        )}
      </Route>
      <Redirect to={EVIDENCE_ROUTE_PATHS.portal} />
    </Switch>
  );
};

export default EvidencePortalRoute;
